export const assetFilterStrings = {
  header: {
    assetFilter: "Asset Filters",
  },
  labels: {
    filterType: "Filter Type",
    filterCount: "Filter Count",
  },
};
